import { render } from "./HeaderPage.vue?vue&type=template&id=70017eec"
import script from "./HeaderPage.vue?vue&type=script&lang=js"
export * from "./HeaderPage.vue?vue&type=script&lang=js"

import "./HeaderPage.vue?vue&type=style&index=0&id=70017eec&lang=css"

import exportComponent from "F:\\allNewWeb\\ant-vue\\antd-demo2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__